import _ from "../../compat/lodashplus";
import $ from "jquery";
// import {base64Pic1, File12, File31, File32, File33 ,File3882545, File4461456} from "../../../CUDENT/base64test"
// import {test1} from "../../../CUDENT/base64test"
// import { File12, } from "../../../CUDENT/base64test"

var AGENT_URL = "https://scan_local.rama.mahidol.ac.th:5555";
var AGENT_URL_V2 = "https://scan_local.rama.mahidol.ac.th:5555";

var CHECK_CAGENT_INSTALLED_MSG = _(
  "กรุณาตรวจสอบว่า CAgent 1.1.9 ถูกติดตั้งและเปิดใช้งานอยู่"
);

var DebugImageCAgent = false

export function _getJson(url: any) {
  return new Promise(function (resolver, rejecter) {
    $.ajax({
      url: url,
      dataType: "json"
    })
      .done(function (responseJSON: any) {
        resolver(responseJSON);
      })
      .fail(function (response: any) {
        console.log(arguments);
        rejecter(response.responseJSON || response.responseText);
      });
  });
}

export function checkScannerAvailable(onAvailable: any, onFail: any) {
  if (DebugImageCAgent) {
    setTimeout(() => {
      onAvailable();
    }, 100);
    return
  }
  $.get(
    AGENT_URL + "/scanner/isAvailable",
    function (result: any) {
      if (result.available === true) {
        onAvailable();
      } else {
        onFail(_("เครื่องสแกนไม่พร้อมใช้งาน"));
      }
    },
    "json"
  ).fail(function () {
    // @ts-ignore
    onFail(_("ไม่สามารถติดต่อเครื่องสแกนได้") + CHECK_CAGENT_INSTALLED_MSG);
  });
}

export function checkCAgentScanListAvailable(this: any, onTrue: any, onFalse: any) {

  if (DebugImageCAgent) {
    setTimeout(() => {
      onTrue()
    }, 100);
    return
  }

  if (this.useDataUri) {
    onTrue()
    return
  }

  function UrlExists(url: any, callback: any) {
    var http = new XMLHttpRequest();
    http.open("HEAD", url);
    http.onreadystatechange = function () {
      if (this.readyState === this.DONE) {
        callback(this.status);
      }
    };
    http.send();
  }

  UrlExists(AGENT_URL + "/scanner/allImage", function (result: any) {
    if (result === 200) {
      onTrue();
    } else {
      onFalse();
    }
  });
}

/**
 *
 *  CAgent.scan(function(base64Image) {
 *  }, function() {
 *  })
 *
 * @param {function} onSuccess
 * @param {function} onFail
 */
export function scan(onSuccess: any, onFail: any, DJANGO: any) {
  // console.log("🚀 ~ file: CAgent.ts ~ line 76 ~ scan ~ scan", scan)

  // For Debug
  // 31 32, Bug
  // 12, 388 Not correct
  // V^0361 
  // D^0000214356 
  // H^61019856$C^041.001$VD^20181228
  // DJANGO.TEST_SCANNED_IMAGE = File12

  // V^0475 
  // D^5836078132 
  // H^57015555$C^037.002$VD^20200908
  // DJANGO.TEST_SCANNED_IMAGE = File31 

  // V^0499 
  // D^5836033932 
  // H^55000713$C^038.002$VD^20201019
  // DJANGO.TEST_SCANNED_IMAGE = File32


  // V^0361
  // D^0000214356
  // H^61019856$C^041.001$VD^20181228
  // DJANGO.TEST_SCANNED_IMAGE = File33


  // V^0572
  // D^0008001014
  // H^54012246$C^042.001$VD^20170429
  // DJANGO.TEST_SCANNED_IMAGE = File3882545


  // V^1356
  // D^0000121302
  // H^54012246$C^043.001$VD^20181026
  // DJANGO.TEST_SCANNED_IMAGE = File13

  // if (DebugImageCAgent) {
  //   if (DJANGO.TEST_SCANNED_IMAGE !== undefined) {
  //     onSuccess("data:image/jpeg;base64," + DJANGO.TEST_SCANNED_IMAGE);
  //     return;
  //   }
  // }

  if (typeof onSuccess !== "function") {
    onSuccess = function () { };
  }
  if (typeof onFail !== "function") {
    onFail = function () { };
  }

  checkScannerAvailable(_doScan, onFail);

  function _doScan() {
    $.get(
      AGENT_URL + "/scanner/scan",
      function (result: any) {
        if (result.success === true) {
          _toDataURL(AGENT_URL + "/scanner/latestImage", function (dataUrl: any) {
            onSuccess(dataUrl); // send data as base64 image
          });
        } else {
          onFail(_("สแกนไม่สำเร็จ"));
        }
      },
      "json"
    );
  }

  function _toDataURL(url: any, callback: any) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }
}

export function scanList(this: any, onSuccess: any, onFail: any) {
  // console.log("🚀 ~ file: CAgent.ts ~ line 158 ~ scanList ~ scanList", scanList)
  // if(DJANGO.TEST_SCANNED_IMAGE !== undefined) {
  //     dataUrl = 'data:text/xml;base64,' + DJANGO.TEST_SCANNED_IMAGE
  //     onSuccess([dataUrl, dataUrl, dataUrl])
  //     return
  // }

  // if (DebugImageCAgent) {
  //   let dataUrl = 'data:image/jpeg;base64,' + File12
  //   let dataUrlBlank = 'data:image/jpeg;base64,' + File12
  //   // onSuccess([dataUrl, dataUrlBlank, dataUrl])
  //   onSuccess([dataUrl, dataUrl, dataUrl, dataUrl, dataUrl])
  //   return
  // }

  if (typeof onSuccess !== "function") {
    onSuccess = function () { };
  }
  if (typeof onFail !== "function") {
    onFail = function () { };
  }

  if (this.useDataUri) {
    _doImagesList()
    return
  }

  checkScannerAvailable(_doScanList, onFail);

  function _doScanList() {
    $.get(
      AGENT_URL + "/scanner/scan",
      function (result: any) {
        if (result.success === true) {
          _toDataURLList(AGENT_URL + "/scanner/allImage", function (dataUrl: any) {
            dataUrl = JSON.parse(dataUrl);
            // console.log("react-lib_toDataURLList dataUrl[0], dataUrl[1]", dataUrl[0], dataUrl[1]);
            console.log("react-lib_toDataURLList dataUrl", dataUrl);
            onSuccess(dataUrl); // send data as base64 image
          });
        } else {
          onFail(_("สแกนไม่สำเร็จ"));
        }
      },
      "json"
    );
  }

  function _doImagesList() {
    _toDataURLList(AGENT_URL_V2 + "/images/list", function (dataUrl: any) {
      dataUrl = JSON.parse(dataUrl);
      dataUrl = dataUrl.map((item: string) => `${AGENT_URL_V2}/images/get?name=${item}`)
      // console.log("react-lib_toDataURLList dataUrl[0], dataUrl[1]", dataUrl[0], dataUrl[1]);
      console.log("react-lib_toDataURLList dataUrl", dataUrl);
      onSuccess(dataUrl); // send data as base64 image
    });
  }

  function _toDataURLList(url: any, callback: any) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsText(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }
}

export function imagesDone(data: string, onSuccess: (result: any) => any, onFail: (result: any) => any) {
  $.post(AGENT_URL_V2 + "/images/done", data, function (result: any) {
    if (result.success === true) {
      onSuccess("Done!");
    } else {
      onFail("Fail!")
    }
  }, "text");
}

export function smartcard(onSuccess: any, onFail: any) {
  if (typeof onSuccess !== "function") {
    onSuccess = function () { };
  }
  if (typeof onFail !== "function") {
    onFail = function () { };
  }
  // use for debug only.
  // onSuccess(_getSuccessMockupData())
  // return

  $.get(
    AGENT_URL + "/smartcard/isAvailable",
    function (result: any) {
      if (result.available === true) {
        _doReadSmartCard();
      } else {
        // Smart card service is not running
        if (result.cause === "no_service") {
          onFail(
            _(
              // eslint-disable-next-line quotes
              'Smart Card Service บน Windows ยังไม่เปิดใช้งาน กรุณาเปิดใช้งานที่ Control Panel -> Services ค้นหา "Smart Card" แล้วคลิกขวาเลือก Start'
            )
          );
        } else if (result.cause === "no_reader") {
          onFail(_("ไม่สามารถเชื่อมต่อเครื่องอ่าน Smart Card"));
        } else {
          onFail(_("เกิดข้อผิดพลาดในการอ่าน Smart Card : Unknown Error"));
        }
      }
    },
    "json"
  ).fail(function () {
    // @ts-ignore
    onFail(_("ไม่สามารถเชื่อมต่อ CAgent Service") + CHECK_CAGENT_INSTALLED_MSG);
  });

  function _doReadSmartCard() {
    $.get(
      AGENT_URL + "/smartcard/read",
      function (result: any) {
        if (result.success === true) {
          onSuccess(result);
        } else {
          if (result.cause.indexOf("RemovedCard") !== -1) {
            onFail(_("กรุณาเสียบบัตร Smart Card"));
          } else {
            onFail(_("เกิดข้อผิดพลาดในการอ่าน Smart Card : " + result.cause));
          }
        }
      },
      "json"
    ).fail(function () {
      onFail(
        // @ts-ignore
        _("ไม่สามารถเชื่อมต่อ CAgent Service") + CHECK_CAGENT_INSTALLED_MSG
      );
    });
  }
}

// trace_id = "หมายเลข invoice 6 หลัก pad 0 ด้านหน้า"
// personal_id = "13 หลัก"
// amount = "จำนวนเงินทศนิยม2ตำแน่ง"

var KTB_EDC_URL_TEMPLATES = {
  isAvailable: AGENT_URL + "/ktbedc/isAvailable",
  coverageGGO: AGENT_URL + "/ktbedc/CoverageGGO?amount={amount}",
  coverageForSon:
    AGENT_URL +
    "/ktbedc/CoverageGGOForSon?CardID={personal_id}&amount={amount}",
  coverageForForeigner:
    AGENT_URL +
    "/ktbedc/CoverageGGOForForeigner?CardID=B{personal_id}&amount={amount}",
  coverageWithoutIDcard:
    AGENT_URL + "/ktbedc/CoverageGGOWithoutIDcard?amount={amount}",
  cancelInvoice: AGENT_URL + "/ktbedc/CancelInvoice?invoice={trace_id}",
  reprintInvoice: AGENT_URL + "/ktbedc/ReprintInvoice?invoice={trace_id}"
};
var KTB_EDC_KEY_MAPPER = {
  statusCode: "00", // response status code
  statusMessage: "02", // response status message
  approvalCode: "01",
  traceId: "65",
  terminalId: "16",
  merchantId: "D1",
  date: "03", // YYMMDD
  time: "04", // HHMMSS
  cardNumber: "30" // HHMMSS
};
export function _ktbedcRequest(targetFunction: any) {
  return _getJson(KTB_EDC_URL_TEMPLATES.isAvailable)
    .catch(function () {
      console.error(arguments);
      throw CHECK_CAGENT_INSTALLED_MSG;
    })
    .then(function (result: any) {
      if (!result.available) {
        console.error(result);
        throw _("ไม่สามารถเชื่อมต่อเครื่อง EDC ได้เนื่องจาก ") + result.cause;
      } else {
        return result;
      }
    })
    .then(function () {
      return targetFunction();
    })
    .then(function (result) {
      var response = result.response;
      var data = _.mapValues(KTB_EDC_KEY_MAPPER, function (value: any) {
        return response[value];
      });
      if (data.statusCode != "00") {
        let a: any = "{0}: {1}";
        console.error(
          a.format(
            result[KTB_EDC_KEY_MAPPER.statusCode],
            result[KTB_EDC_KEY_MAPPER.statusMessage]
          )
        );
        console.error(response);
        throw data;
      } else {
        return data;
      }
    });
}
export function ktbedcApprove(personal_id: any, amount: any, type: any) {
  var URL_TYPE_MAPPER: any = {
    SELF: KTB_EDC_URL_TEMPLATES.coverageGGO,
    CHILD: KTB_EDC_URL_TEMPLATES.coverageForSon,
    FOREIGNER: KTB_EDC_URL_TEMPLATES.coverageForForeigner,
    NO_CARD: KTB_EDC_URL_TEMPLATES.coverageWithoutIDcard
  };

  var url_template = URL_TYPE_MAPPER[type];
  if (!url_template) return Promise.reject("invalid type");
  if (!personal_id || personal_id.length != 13)
    return Promise.reject("invalid personal_id length");
  if (!amount || !parseFloat(amount))
    return Promise.reject("invalid amount value");

  var data = {
    personal_id: personal_id, // เลขบัตรประจำตัวประชาชน 13 หลัก
    amount: parseFloat(amount).toFixed(2) // จำนวนเงินทศนิยม 2 ตำแหน่ง
  };
  return _ktbedcRequest(function () {
    return _getJson(url_template.format(data));
  });
}
export function ktbedcVoid(trace_id: any) {
  if (!trace_id || trace_id.length > 6)
    return Promise.reject("invalid trace_id");

  var data = {
    trace_id: _.padStart(trace_id, 6, "0") // หมายเลข invoice 6 หลัก pad 0 ด้านหน้า
  };
  return _ktbedcRequest(function () {
    let a: any = KTB_EDC_URL_TEMPLATES.cancelInvoice;
    return _getJson(a.format(data));
  });
}
export function ktbedcReprint(trace_id: any) {
  if (!trace_id || trace_id.length > 6)
    return Promise.reject("invalid trace_id");

  var data = {
    trace_id: _.padStart(trace_id, 6, "0") // หมายเลข invoice 6 หลัก pad 0 ด้านหน้า
  };
  return _ktbedcRequest(function () {
    let a: any = KTB_EDC_URL_TEMPLATES.reprintInvoice;
    return _getJson(a.format(data));
  });
}

// use for debug only.
export function _getSuccessMockupData() {
  var data: any = {};
  data["success"] = true;
  data["citizen_id"] = "2456823030740";
  data["birth_date"] = "30/12/2532";
  data["sex"] = 1;
  data["th_prefix"] = "นาย";
  data["th_firstname"] = "ทดสอบ";
  data["th_lastname"] = "สมาทการ์ด";
  data["en_prefix"] = "Khun";
  data["en_firstname"] = "TodSorb";
  data["en_lastname"] = "SmartCard";
  data["address"] = "test";
  data["addr_house_no"] = "18/52";
  data["addr_village_no"] = "หมู่ที่4";
  data["addr_lane"] = "18";
  data["addr_road"] = "พระราม2";
  data["addr_tambol"] = "แขวงท่าข้าม";
  data["addr_amphur"] = "เขตบางขุนเทียน";
  data["addr_province"] = "จังหวัดกรุงเทพมหานคร";
  data["picture_base64"] = _getBase64ImageMockupData();
  data["issuer"] = "เขตบางขุนเทียน";
  data["issue_date"] = "30/12/2555";
  data["expire_date"] = "31/12/2565";
  return data;
}

// use for debug only.
export function _getBase64ImageMockupData() {
  return "data:image/jpeg;base64,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";
}

// use for debug only
export function setMockupScannedImage(DJANGO: any) {
  DJANGO.TEST_SCANNED_IMAGE = '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'
}
